"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import '../../styled-system/css/css.mjs';
import '../../styled-system/helpers.mjs';
import { sva } from '../../styled-system/css/sva.mjs';
import { IconButton } from '../../ui-kit/styled/icon-button.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';

const dropdownClearSearchButtonRecipe = sva({
  className: "dropdown-clear-search-button",
  slots: ["container", "button", "icon", "title"],
  base: {
    button: {
      h: "6",
      w: "6",
      minW: "unset",
      rounded: "md",
      color: "slate.11",
      _current: {
        bg: "slate.3"
      }
    },
    icon: {
      w: "4",
      h: "4"
    }
  }
});
const ClearSearchButton = forwardRef(
  ({ className, ...props }, ref) => {
    const { button, icon } = dropdownClearSearchButtonRecipe();
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        ref,
        variant: "ghost",
        colorPalette: "gray",
        className: clsx(button, className),
        "aria-label": "Clear search",
        ...props,
        children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close, className: icon })
      }
    );
  }
);

export { ClearSearchButton };
